import React from "react";
import { ButtonProps, Button } from "../button/Button";
import { colors } from "../colors/color";
import { Flex } from "../compositeComponents/FlexHelpers";
import { iconName, Icon } from "../icons/Icons";
import { Small } from "../typography/Body";
import styled from "styled-components";

type ListItemProps = {
    leadingIcon:iconName,
    leadingIconColor?: string,
    primaryText:string,
    secondary?:{
        leadingIcon?:iconName,
        text:string
    },
    button?:ButtonProps
};
export function ListItem(props: ListItemProps):JSX.Element
{
    return (
        <Flex gap={16} alignItems="center" justifyContent="space-between" width="100%">
            <Flex flexDirection="column" grow="1">
                <Flex gap={8} alignItems="center">
                    <Icon name={props.leadingIcon} color={props.leadingIconColor || colors.icon.default} size="x-small" />
                    <span>{props.primaryText}</span>
                </Flex>
                {props.secondary &&
                    <div style={{marginLeft: "22px", display: "flex", alignItems: "center", gap: "8px"}}>
                        {props.secondary.leadingIcon &&
                            <Icon name={props.secondary.leadingIcon} size="x-small" />
                        }
                        <Small>{props.secondary.text}</Small>
                    </div>
                }
            </Flex>
            
            {props.button &&
                <div style={{flexGrow: 0}}>
                    <Button {...props.button} />
                </div>
            }
        </Flex>
    );
}

type ButtonListItemProps = Omit<ListItemProps, 'button'> & {
    onClick?: () => void
};
export function ButtonListItem(props: ButtonListItemProps): JSX.Element
{
    return (
        <ButtonWrapper onClick={props.onClick}>
            <ListItem {...props} />
        </ButtonWrapper>
    );
}

const ButtonWrapper = styled.button`
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: "Noto Sans", sans-serif;
    font-size:16px;
    color:${colors.text.normal};
    font-weight:300;
    border-radius:4px;

    &:hover {
        background-color: ${colors.button.text.backgroundHover};
    }
`;